import Lenis from "../../build/node_modules/@studio-freight/lenis";
//
import Util from "./Util.js";
import { gsap } from "./Util.js";
import { ScrollTrigger } from "../_libs/ScrollTrigger";

class Scroll extends Util {
  constructor() {
    super();
    this.init();
  }

  init() {
    this.start();
    this.events();
    this.startRaf();
    this.anchor();
    this.commonHeader();

    if (window.website.page === "top") {
      this.aboutNav();
      this.scaleImg();
      this.stickyScaleImg();
    } else if (window.website.page === "business-partner") {
      this.mvScaleImg();
      this.scaleImg();
      this.stickyScaleImg();
      this.businessPartnerProcess();
    } else if (window.website.page === "membership") {
      this.mvScaleImg();
      this.scaleImg();
      this.stickyScaleImg();
    } else if (window.website.page === "about") {
      this.aboutNav();
      this.scaleImg();
      this.stickyScaleImg();
    } else {
      this.stickyScaleImg();
    }
  }

  start() {
    this.lenis = new Lenis({
      duration: 0.35,
      direction: "vertical",
      gestureDirection: "vertical",
      smooth: true,
      mouseMultiplier: 0.5,
      smoothTouch: false,
      touchMultiplier: 1,
      infinite: false,

      easing: function (t) {
        // return Math.min(1, 1.005 - Math.pow(2, -10 * t));
        return Math.min(1, 1.01 - Math.pow(100, -1 * t));
      },
    });
    // gsap.delayedCall(0.4, () => {
    //   this.lenis.scrollTo(0, 0);
    // });

    document.addEventListener("DOMContentLoaded", () => {
      gsap.delayedCall(1, () => {
        if (document.URL.includes("#")) {
          const hash = document.URL.split("#")[1];
          if (hash) {
            const targetElement = document.getElementById(hash);
            if (targetElement) {
              this.lenis.scrollTo(targetElement.getBoundingClientRect().top + window.pageYOffset);
            }
          }
        }
      });
    });
  }

  events() {
    this.footer = document.querySelector("#footer");
    this.lenis.on("scroll", (e) => {
      this.website.currentY = e.scroll;
      this.website.velocity = e.velocity;
      const footerTop = this.footer.getBoundingClientRect().top;
      if (this.website.winH / 1.5 > footerTop) {
        document.documentElement.classList.add("nav-hide");
      } else {
        document.documentElement.classList.remove("nav-hide");
      }
    });
  }

  mvScaleImg() {
    const mvScaleImg = document.querySelector(".mv-scale-img");

    ScrollTrigger.create({
      trigger: mvScaleImg,
      start: () => "top",
      end: "bottom",
      // markers: true,
      onUpdate: (self) => {
        gsap.to(mvScaleImg, 0.8, {
          scale: 1 + self.progress * 0.1,
        });
      },
    });
  }

  scaleImg() {
    const stickyScaleImg = document.querySelectorAll(".scale-img");

    stickyScaleImg.forEach((img) => {
      ScrollTrigger.create({
        trigger: img,
        start: () => `-=${window.innerHeight}`,
        end: "bottom",
        // markers: true,
        onUpdate: (self) => {
          const scale = (1 - self.progress) * 0.1;
          gsap.to(img.children[0].children[2], 0.8, {
            scale: 1.1 + scale,
          });
        },
      });
    });
  }

  stickyScaleImg() {
    const stickyScaleImg = document.querySelectorAll(".sticky-scale-img");

    stickyScaleImg.forEach((img) => {
      ScrollTrigger.create({
        trigger: img,
        start: () => `-=${window.innerHeight}`,
        end: "top",
        // markers: true,
        onUpdate: (self) => {
          const scale = (1 - self.progress) * 0.1;
          gsap.to(img.children[0].children[2], 0.8, {
            scale: 1.1 + scale,
          });
        },
      });
    });
  }

  startRaf() {
    const raf = (time) => {
      this.lenis.raf(time);
      requestAnimationFrame(raf);
    };
    requestAnimationFrame(raf);
  }

  anchor() {
    // const toTop = document.querySelector(".to-top");
    // toTop.addEventListener("click", () => {
    //   this.lenis.scrollTo(0);
    // });

    const anchors = document.querySelectorAll(".anchor");
    anchors.forEach((anchor) => {
      anchor.addEventListener("click", (e) => {
        e.preventDefault();
        const targetElement = anchor.getAttribute("href").split("#")[1];
        const targetDOM = document.getElementById(targetElement);
        const top = targetDOM.getBoundingClientRect().top;
        this.lenis.scrollTo(top + window.pageYOffset);
      });
    });
  }

  aboutNav() {
    const team = document.getElementById("team");
    const anchors = document.querySelectorAll("#about .anchor");

    ScrollTrigger.create({
      trigger: team,
      start: "top",
      end: "bottom",
      // markers: true,
      scrub: true,
      onEnter: (self) => {
        anchors.forEach((anchor) => {
          anchor.classList.remove("current");
        });
        anchors[1].classList.add("current");
      },
      onLeaveBack: (self) => {
        anchors.forEach((anchor) => {
          anchor.classList.remove("current");
        });
        anchors[0].classList.add("current");
      },
    });
  }

  businessPartnerProcess() {
    const trigger = document.querySelector(".s3 .process");
    const line = document.querySelector(".s3 .process .line span");

    ScrollTrigger.create({
      trigger: trigger,
      start: () => `-=${window.innerHeight / 2}`,
      end: () => `bottom-=${window.innerHeight / 2}`,
      // markers: true,
      onUpdate: (self) => {
        gsap.set(line, {
          scaleY: self.progress,
        });
      },
    });
  }

  commonHeader() {
    if (document.querySelector(".header-change-line")) {
      const header = document.querySelector("#header");
      ScrollTrigger.create({
        trigger: ".header-change-line",
        start: "top",
        end: "bottom",
        onEnter: (self) => {
          header.classList.remove("white");
        },
        onLeaveBack: (self) => {
          header.classList.add("white");
        },
      });
    }
  }
}

gsap.registerPlugin(ScrollTrigger);
export default Scroll;
